const offerSegments = [
  "Free for a limited time",
  "Profile verification free",
  "First collaboration free",
];

const statsSegments = [
  "500+ Companies Onboarded",
  "6 Continents Covered",
  "No Commission & No Profit Share",
];

function OfferChunk({
  chunkKey,
  ariaHidden,
}: {
  chunkKey: string;
  ariaHidden?: boolean;
}) {
  return (
    <span
      className="navbar-marquee-chunk navbar-marquee-chunk--offer"
      aria-hidden={ariaHidden ? true : undefined}
    >
      {offerSegments.map((item) => (
        <span
          key={`${chunkKey}-offer-${item}`}
          className="marquee-seg marquee-seg--ny marquee-seg--offer"
        >
          <strong>{item}</strong>
          <span className="marquee-sep" aria-hidden="true">
            ·
          </span>
        </span>
      ))}
    </span>
  );
}

function StatsChunk({
  chunkKey,
  ariaHidden,
}: {
  chunkKey: string;
  ariaHidden?: boolean;
}) {
  return (
    <span
      className="navbar-marquee-chunk navbar-marquee-chunk--stats"
      aria-hidden={ariaHidden ? true : undefined}
    >
      {statsSegments.map((item) => (
        <span
          key={`${chunkKey}-stats-${item}`}
          className="marquee-seg marquee-seg--ny marquee-seg--stats"
        >
          <strong className="marquee-text-white">{item}</strong>
          <span className="marquee-sep" aria-hidden="true">
            ·
          </span>
        </span>
      ))}
    </span>
  );
}

export default function NavbarMarqueeBand() {
  return (
    <div
      className="navbar-marquee-band"
      role="region"
      aria-label="Limited-time offer: free profile verification, first collaboration, and first cycle"
    >
      <div className="navbar-marquee-mask">
        <div className="navbar-marquee-track">
          <OfferChunk chunkKey="a" />
          <StatsChunk chunkKey="a" ariaHidden />
          <OfferChunk chunkKey="b" ariaHidden />
          <StatsChunk chunkKey="b" ariaHidden />
          <OfferChunk chunkKey="c" ariaHidden />
          <StatsChunk chunkKey="c" ariaHidden />
        </div>
      </div>
    </div>
  );
}
